import React from 'react';
import PropTypes from 'prop-types';

import SrButton, { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrStaticFooter from 'client/components/SrStaticFooter';
import SrSecureTextLabel from 'client/components/SrSecureTextLabel';

const SrConnectBankAccountFormFooter = ({ buttonText, buttonTheme, onNext, disabled }) => {
  return (
    <SrStaticFooter>
      <SrButton
        theme={buttonTheme || SR_BUTTON_THEME_ADOBE_GREEN}
        onClick={onNext}
        disabled={disabled}
        width="100%"
        hasBoxShadow
      >
        {buttonText}
      </SrButton>
      <SrBox margin="3px auto 0">
        <SrSecureTextLabel>Secure Connection</SrSecureTextLabel>
      </SrBox>
    </SrStaticFooter>
  );
};

SrConnectBankAccountFormFooter.propTypes = {
  buttonText: PropTypes.string,
  buttonTheme: PropTypes.string,
  onNext: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

SrConnectBankAccountFormFooter.defaultProps = {
  buttonText: 'Next',
};

SrConnectBankAccountFormFooter.displayName = 'SrConnectBankAccountFormFooter';

export default SrConnectBankAccountFormFooter;
